import type { Period } from '../utils/resolution'
import { isIntradayPeriod } from '../utils/resolution'

/**
 * Period-aware replay clock: intraday shows the TIME only (`09:30`), daily+ the
 * full date (`2026-05-01`).
 *
 * Intraday drops the date deliberately: the panel-header calendar states which
 * day the session is on, and repeating it in the strip made the chip wide
 * enough to crowd the controls next to it. On daily+ the day IS the cursor, so
 * it stays.
 *
 * Pure, and housed in its own .ts module so ReplayControls.tsx exports only
 * components (react-refresh).
 */
export function formatReplayClock(
  cursorTs: number | null,
  period: Period,
  timezone = 'America/New_York',
): string {
  if (cursorTs == null) return '—'
  const intraday = isIntradayPeriod(period)
  try {
    const d = new Date(cursorTs)
    if (!intraday) {
      // en-CA renders YYYY-MM-DD.
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(d)
    }
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(d)
  } catch {
    return new Date(cursorTs).toISOString()
  }
}
